import UseSendTwoFactor from './hooks/useSendTwoFactor'
import LoginSendCode from '../../../assets/images/auth/Group 392.svg'
import { Form, Formik } from 'formik'
import FormikInput from '../../../components/formikFields/input'
import { useLocation } from 'react-router-dom'

const TwoFactorLogin = () => {
    const { mutate } = UseSendTwoFactor()
    const location = useLocation()

    const handleSubmit = async (values) => {
        mutate({
            password: values.password,
            phone_number: location.state.phone_number,
            two_factor_token: location.state.two_factor_token,
        })
    }


    return (
        <>
            <div className='flex flex-col justify-center items-center h-screen relative mx-6 '>
                <div className='w-full'>
                    <div className='mt-20'>
                        <img
                            alt='login send code'
                            src={LoginSendCode}
                            className='block m-auto mb-10 w-32'
                        />
                        <p className='text-center mt-4 text-green-1 text-3xl font-extrabold mb-6 '>
                            ورود دو مرحله‌ای
                        </p>
                    </div>
                    <Formik
                        initialValues={{ password: '' }}
                        onSubmit={handleSubmit}>
                        <Form>
                            <div dir='ltr'>
                                <FormikInput
                                    name='password' label='رمز ورود دو مرحله‌ای'
                                    placeholder='رمز ورود دو مرحله‌ای را وارد کنید' type='password'
                                />
                            </div>
                            <div>
                                <button
                                    type='submit'
                                    className=' w-full bg-green-1 text-white rounded-2xl py-3 my-3'
                                >
                                    تایید
                                </button>
                            </div>
                        </Form>
                    </Formik>
                </div>
            </div>
        </>
    )
}

export default TwoFactorLogin